"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "sestri-levante": {
    "05abab2d": [{
      "hkey": "72a9953c",
      "slug": "sestri-levante",
      "name": "Sestri Levante",
      "primary": true,
      "skipSearch": false
    }],
    "pila-sul-gromolo": [{
      "hkey": "72a9953c",
      "slug": "sestri-levante",
      "name": "Sestri Levante",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0aadc163": [{
      "hkey": "6156d273",
      "slug": "san-bartolomeo-della-ginestra",
      "name": "San Bartolomeo della Ginestra",
      "primary": true,
      "skipSearch": false
    }],
    "san-bartolomeo": [{
      "hkey": "6156d273",
      "slug": "san-bartolomeo-della-ginestra",
      "name": "San Bartolomeo della Ginestra",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "a835130d": [{
      "hkey": "1346d568",
      "slug": "cascine-san-bernardo-villa-costarossa",
      "name": "Cascine-San Bernardo-Villa Costarossa",
      "primary": true,
      "skipSearch": false
    }],
    "san-bernardo": [{
      "hkey": "1346d568",
      "slug": "cascine-san-bernardo-villa-costarossa",
      "name": "Cascine-San Bernardo-Villa Costarossa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "7ad73481": [{
      "hkey": "9656882a",
      "slug": "fossa-lupara",
      "name": "Fossa Lupara",
      "primary": true,
      "skipSearch": false
    }],
    "santa-margherita-di-fossa-lupara": [{
      "hkey": "9656882a",
      "slug": "fossa-lupara",
      "name": "Fossa Lupara",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "072e7236": [{
      "hkey": "3c88d80a",
      "slug": "santa-vittoria-villa-scorza-villa-zarello",
      "name": "Santa Vittoria-Villa Scorza-Villa Zarello",
      "primary": true,
      "skipSearch": false
    }],
    "santa-vittoria": [{
      "hkey": "3c88d80a",
      "slug": "santa-vittoria-villa-scorza-villa-zarello",
      "name": "Santa Vittoria-Villa Scorza-Villa Zarello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "4ded9c8d": [{
      "hkey": "4e3fa5fe",
      "slug": "villa-azaro-villa-loto",
      "name": "Villa Azaro-Villa Loto",
      "primary": true,
      "skipSearch": false
    }],
    "villa-azaro": [{
      "hkey": "4e3fa5fe",
      "slug": "villa-azaro-villa-loto",
      "name": "Villa Azaro-Villa Loto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "5f8ad057": [{
      "hkey": "1346d568",
      "slug": "cascine-san-bernardo-villa-costarossa",
      "name": "Cascine-San Bernardo-Villa Costarossa",
      "primary": true,
      "skipSearch": false
    }],
    "villa-cascine": [{
      "hkey": "1346d568",
      "slug": "cascine-san-bernardo-villa-costarossa",
      "name": "Cascine-San Bernardo-Villa Costarossa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "sestri-levante"
    }],
    "976aea77": [{
      "hkey": "1346d568",
      "slug": "cascine-san-bernardo-villa-costarossa",
      "name": "Cascine-San Bernardo-Villa Costarossa",
      "primary": true,
      "skipSearch": false
    }],
    "villa-costarossa": [{
      "hkey": "1346d568",
      "slug": "cascine-san-bernardo-villa-costarossa",
      "name": "Cascine-San Bernardo-Villa Costarossa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "sestri-levante"
    }],
    "52b1c2fe": [{
      "hkey": "46d7b115",
      "slug": "balicca-e-ponterotto-villa-libiola",
      "name": "Balicca e Ponterotto-Villa Libiola",
      "primary": true,
      "skipSearch": false
    }],
    "villa-libiola": [{
      "hkey": "46d7b115",
      "slug": "balicca-e-ponterotto-villa-libiola",
      "name": "Balicca e Ponterotto-Villa Libiola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "dcff076f": [{
      "hkey": "4e3fa5fe",
      "slug": "villa-azaro-villa-loto",
      "name": "Villa Azaro-Villa Loto",
      "primary": true,
      "skipSearch": false
    }],
    "villa-loto": [{
      "hkey": "4e3fa5fe",
      "slug": "villa-azaro-villa-loto",
      "name": "Villa Azaro-Villa Loto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "sestri-levante"
    }],
    "d1d5c2c0": [{
      "hkey": "6010955c",
      "slug": "villa-tassani-villa-vignolo",
      "name": "Villa Tassani-Villa Vignolo",
      "primary": true,
      "skipSearch": false
    }],
    "villa-tassani": [{
      "hkey": "6010955c",
      "slug": "villa-tassani-villa-vignolo",
      "name": "Villa Tassani-Villa Vignolo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;